// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__GNwkF","navText":"Navbar_navText__1S7Vm","navLogo":"Navbar_navLogo__ZCk2-","imgLogo":"Navbar_imgLogo__oSGmz"};